import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GenericResponse } from '@otas/model/genericResponse';
import { PrinterConfigWithPaperType } from '@otas/model/current-user';
import * as _ from 'underscore';
import { GlobalUtilService } from '@otas/core/services/global-util.service';

import { FilesService } from '@otas/shared/files.service';
import { PrintConfigFileService } from '@otas/stoda-settings/printing-options/print-config-file.service';

@Injectable()
export class PrinterSettingsService {

  /**
   * Keys with these suffixes belong to the Printing options page
   * (printing-options component) and must survive a save from this screen.
   */
  private static readonly FOREIGN_KEY_SUFFIXES = ['.method.order', '.font.size'];

  constructor(private http: HttpClient, private globalUtilService: GlobalUtilService
    , private fileService: FilesService, private printConfigFile: PrintConfigFileService) { }
  submit(obj): Observable<GenericResponse<any>> {
    const url = `temple/setting`;
    return this.http.put<GenericResponse<any>>(url, obj);
  }
  savePrinterConfigs(obj): Observable<GenericResponse<any>> {
    const url = `temple/printer/setting`;
    return this.http.put<GenericResponse<any>>(url, obj);

  }
  getPrintConfigs(): Observable<GenericResponse<PrinterConfigWithPaperType>> {
    return this.http.get<GenericResponse<PrinterConfigWithPaperType>>('temple/printconfig');

  }
  saveToConfigFile(invoiceConfigs) {
    const detailedConfigs = _.mapObject(invoiceConfigs);
    console.log(detailedConfigs,"detailedConfigs")
    const configsForFile = {};
    for (const key in detailedConfigs) {
      if (detailedConfigs.hasOwnProperty(key)) {
        configsForFile[key] = {};
        for (const subKey in detailedConfigs[key]) {
          if (detailedConfigs[key].hasOwnProperty(subKey)) {
            
            if (detailedConfigs[key].template === 'Custom') {
              configsForFile[key][subKey] = detailedConfigs[key][subKey];
            } else if (key !== 'temple') {
              configsForFile[key].template = detailedConfigs[key].template;
            } else if (key === 'temple') {
              configsForFile[key] = detailedConfigs[key];
            }
            if (subKey === 'margin') {
              configsForFile[key][subKey] = detailedConfigs[key][subKey];
            }
            if (subKey === 'printer') {
              configsForFile[key][subKey] = detailedConfigs[key][subKey].testValue;
            }
          }
        }
      }
    }

    // Merge-safe write (fix): this method used to REBUILD print-config.properties
    // from the DB config objects only, silently dropping every key it does not
    // manage (e.g. <type>.method.order saved by the Printing options page, or
    // manually added keys such as email.smtp.*). Now the existing file is read
    // first and all unknown keys are carried over; the keys this screen manages
    // keep their previous rebuild semantics (stale managed keys are still dropped).
    if(this.globalUtilService.isTauriApp)  {
      const ownMap = this.printConfigFile.entriesToMap(this.fileService.deflate(configsForFile, ''));
      // sections this save actually rebuilds (pooja/expense/.../temple)
      const managedSections = Object.keys(configsForFile);
      this.printConfigFile.readKeyMap().then(existing => {
        const merged: { [key: string]: string } = {};
        for (const key of Object.keys(existing.map)) {
          if (!this.isManagedKey(key, managedSections)) {
            merged[key] = existing.map[key];
          }
        }
        Object.assign(merged, ownMap);
        return this.printConfigFile.writeKeyMap(merged);
      }).then(() => {
        console.log('print-config.properties updated (merge-safe)');
      }).catch(r => {
        console.log(r);
      });
    }

  }

  /** True for keys this save rebuilds (their stale variants may be dropped). */
  private isManagedKey(key: string, managedSections: string[]): boolean {
    if (PrinterSettingsService.FOREIGN_KEY_SUFFIXES.some(suffix => key.endsWith(suffix))) {
      return false;
    }
    return managedSections.indexOf(key.split('.')[0]) >= 0;
  }

  readConfigFile() {
    if (this.globalUtilService.isTauriApp && this.globalUtilService.process) {
      return this.fileService.readFile(this.globalUtilService.configPath + '\\print-config.properties');
    } else {
      return new Promise((resolve, reject) => { });
    }
  }
}
